import type { Feature, Polygon } from '@turf/turf';
import type { Dictionary } from 'redux-ngrx-entity';

export enum CloudOptions {
  'sunny' = 'sunny',
  'sunny_cloudless' = 'sunny_cloudless',
  'overcast' = 'overcast',
}

export enum CWOImageSource {
  PLANET = 'ps8',
  SENTINEL_2A = 's2a',
  SENTINEL_2B = 's2b',
  DRONE = 'drone',
}

export enum RemoteSensingImageSource {
  PLANET = 'planet_sr',
  SENTINEL_L2A = 'sentinel_l2a',
  SENTINEL = 'sentinel',
  DRONE = 'drone',
}

export enum Source {
  PLANET = 'planet',
  SENTINEL = 'sentinel',
  DRONE = 'drone',
}

export enum SourceLabel {
  sentinel = 'sentinel',
  planet = 'planet',
  drone = 'drone',
}

export type AssetSource =
  | 'blackbridge'
  | 'sentinel'
  | 'sentinel_2a'
  | 'planet'
  | 'deimos'
  | 'spot'
  | 'terravion'
  | 'drone'
  | 'syso'
  | 'planet_sr'
  | 's2a'
  | 'ps8'
  | 's2b';

export interface ImageAOIResponse {
  readonly content: ReadonlyArray<ImageAOI_DTO>;
}

export interface ImageAOI_DTO {
  readonly acquired_at: string;
  readonly extra_attributes: {
    readonly image_metadata: {
      readonly stats: Dictionary<ImageStat>;
    };
  };
  readonly geojson: string | null;
  readonly id: string;
  readonly from_composite_image_id: string;
  readonly image_cloud_coverage: number | null;
  readonly last_processed_at: string;
  readonly scene_cloud_coverage: number | null;
  readonly scenes: ReadonlyArray<string>;
  readonly source: string;
  readonly sub_products: ReadonlyArray<string>;
  readonly aoi: {
    readonly type: string;
    readonly uid: string;
    readonly property_id: string;
    readonly org_id: string;
  };
  readonly scene_bounds?: Feature<Polygon>;
  readonly composed_of?: Dictionary<ImageAOI_DTO>;
  readonly _tile?: string;
}

export interface ImageStat {
  readonly data_coverage: number;
  readonly max: number | null;
  readonly min: number | null;
  readonly mean: number | null;
  readonly std: number | null;
}

export interface ImageAOI {
  readonly id: string; // Image ID
  readonly sceneId: string;
  readonly acquiredAt: string;
  readonly geojson: string | null;
  readonly fromCompositeImageId: string;
  readonly imageCloudCoverage: number;
  readonly sceneCloudCoverage: number;
  readonly lastProcessedAt: string;
  readonly bounds?: Feature<Polygon>;
  readonly source: Source;
  readonly subProducts: ReadonlyArray<string>;
  readonly aoi: {
    readonly type: string;
    readonly uid: string;
    readonly property_id: string;
  };
  readonly composedOf: Dictionary<ImageAOI>;
  readonly tilePath?: string;
  readonly stats: Dictionary<ImageStat>;
}

export interface SceneGroup {
  id: string;
  referenceImage: ImageAOI;
  images: ImageAOI[];
}
